export default __webpack_public_path__ + "static/media/les_andelys12.7232ef25.jpg";